$(() => {

  const $menu = $('.inner-menu'),
    $menuWrapper = $('.bs-div--fixed-inner-menu'),
    headerHeight = parseInt($('header .container').height());
  let heightMenu = 0,
    adminBarHeight = 0;
  if ($menuWrapper.length) {
    heightMenu = $menuWrapper.offset().top - headerHeight - 20;
  }

  function isElementPartiallyInViewport(el) {
    if (typeof $ !== "undefined" && el instanceof $) el = el[0];
    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const vertInView = (rect.top <= windowHeight / 3) && ((rect.top + rect.height) >= 0);
    return vertInView;
  }

  $(window).on('load scroll resize', () => {
    let scrolled_height = $(window).scrollTop();
    if ($menuWrapper.length) {
      if ($(window).width() > 1199) {
        if (scrolled_height >= heightMenu) {
          $menuWrapper.addClass('position-set');
        } else {
          $menuWrapper.removeClass('position-set');
        }
      }
    }

    $('section').each((index, element) => {
      const el = $(element),
        inVpPartial = isElementPartiallyInViewport(el);
      if (inVpPartial) {
        el.addClass('active viewed');
      } else {
        el.removeClass('active')
      }
      const activeSection = $('section.active').last().attr('id');
      $menu.find('.menu-item').removeClass('active');
      if (activeSection != '' && activeSection != undefined) {
        $menuWrapper.find(`a[href='#${activeSection}']`).parent('.menu-item').addClass('active');
      }
    });
  });

  $menuWrapper.find('a[href^="#"]').each((index, element) => {
    const $this = $(element),
      $parentDiv = $this.parents('.bs-div--inner-menu');
    $this.on('click', (e) => {
      if ($("#wpadminbar").length) {
        adminBarHeight = parseInt($('#wpadminbar').outerHeight() - 20);
      }
      e.preventDefault();
      if ($($this.attr('href')).length) {
        let offsetPosition = $($this.attr('href')).offset().top - $('header .container').height() - 80 - adminBarHeight;
        $parentDiv.find('li').removeClass('active');
        $this.parent().addClass('active');
        if ($('.position-set').length) {
          offsetPosition = offsetPosition - adminBarHeight;
        }
        $('html, body').stop().animate({
          scrollTop: offsetPosition
        }, 1000);
      }
    });
  });

  $('.bs-div--inner-menu.bs-div--content-wrapper').each((index, element) => {
    const $this = $(element);
    let activeLeft = $this.find('.current-menu-item').offset().left;
    if ($this.find('.menu-item ').first().hasClass('current-menu-item')) {
      activeLeft = 0;
    }
    if (activeLeft != '' && activeLeft != undefined) {
      $this.children('.bs-div__inner').children('div').animate({ scrollLeft: activeLeft }, 100);
    }
  });


});